import { NgModule } from '@angular/core';
import { LoaderComponent } from './loader.component';

@NgModule({
    imports: [],
    exports: [
        LoaderComponent
    ],
    declarations: [
        LoaderComponent
    ]
})

export class LoaderComponentModule {
}
